
export class User {
  public id?: string;
  public rights?: string[];
  public roles?: string[];
  public login?: string;
  public email?: string;
  public firstname?: string;
  public lastname?: string;
  public password?: string;
  public picture?: string;

  constructor(obj?: any) {
    let data = {
      rights: [],
      roles: [],
      ...(obj || {})
    };

    this.id = data.id;
    this.rights = data.rights;
    this.roles = data.roles;
    this.login = data.login;
    this.email = data.email;
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.picture = data.picture;
  }

  get fullname (): string {
    if(!this.firstname && !this.lastname) {
      return this.login;
    }
    return this.firstname + ' ' + this.lastname;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user.class.ts